import React from "react";
import { connect } from "react-redux";
import { saveForm } from "../../store/actions/actionForm";

const Form = ({ children, onSubmit, values, saveFormValues, ...props }) => {
  const { id: idForm } = props;

  const handleSubmitForm = (e) => {
    e.preventDefault();
    if (idForm) saveFormValues(idForm, values);
    onSubmit();
  };

  return (
    <form autoComplete="off" onSubmit={handleSubmitForm} {...props}>
      {children}
    </form>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    saveFormValues: (idForm, values) => dispatch(saveForm(idForm, values)),
  };
}

export default connect(null, mapDispatchToProps)(Form);
